import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-smash-external-html',
    templateUrl: './smash-external-html.component.html',
    styleUrls: ['./smash-external-html.component.scss'],
})
export class SmashExternalHtmlComponent implements OnInit, OnChanges {
    @Input('externalContent') externalContent: string;
    content;

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

    ngOnInit(): void {
        this.http.get(this.externalContent, { responseType: 'text' })
            .subscribe(res => this.content = this.sanitizer.bypassSecurityTrustHtml(res))
    }

    ngOnChanges(changes: SimpleChanges) {
        this.http.get(this.externalContent, { responseType: 'text' })
            .subscribe(res => this.content = this.sanitizer.bypassSecurityTrustHtml(res));
    }

}